import { render, staticRenderFns } from "./CategoryUpsertComponent.vue?vue&type=template&id=4f3ca349&"
import script from "./CategoryUpsertComponent.vue?vue&type=script&lang=ts&"
export * from "./CategoryUpsertComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports